import { createContext, useContext, useEffect, useState } from 'react';

const STORAGE_KEY = 'rk-text-size';
const TextSizeContext = createContext({ textSize: 'md', setTextSize: () => {} });

export function TextSizeProvider({ children }) {
  const [textSize, setTextSizeState] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) || 'md';
    } catch {
      return 'md';
    }
  });

  const setTextSize = (size) => {
    setTextSizeState(size);
    try {
      localStorage.setItem(STORAGE_KEY, size);
    } catch {
      /* ignore */
    }
  };

  useEffect(() => {
    document.documentElement.setAttribute('data-text-size', textSize);
  }, [textSize]);

  return (
    <TextSizeContext.Provider value={{ textSize, setTextSize }}>
      {children}
    </TextSizeContext.Provider>
  );
}

export function useTextSize() {
  return useContext(TextSizeContext);
}
